export const styles = theme => ({
    otherProducts: {
        marginTop: 177,
        marginBottom: 24,
        textAlign: "center",
        fontSize: 34,
        fontWeight: 700,
    } as const
});